/**
 * Type guard to check if a given value is one of the values of a specified enum.
 * T - Enum type extending Record<string, string | number>.
 * @param value - The value to check.
 * @param enumObj - The enum object to validate against.
 * @returns True if the value is part of the enum, otherwise false.
 */
export const isValueOfEnum = <T extends Record<string, string | number>>(
  value: unknown,
  enumObj: T,
): value is T[keyof T] => Object.values(enumObj).some((v) => v === value);
